import { FlexAligner } from '@scaleaq/scaleui';
import { styled } from 'styled-components';

import { controlsRightInset } from '../cameraStreamControls.tokens.ts';

/** Right-side rail for camera switching and stream-quality toggle; shares the edge inset
    with the bottom-right pause and rewind buttons so all right-side controls line up. */
export const StyledSideControlsRail = styled(FlexAligner)<{ $zIndex: number }>`
  position: absolute;
  right: ${controlsRightInset};
  top: 40%;
  z-index: ${({ $zIndex }) => $zIndex};
`;
